import React from "react";
import { PlatformLayout } from "./PlatformLayout";
import AcquereurExperience from "./AcquereurExperience";

export default function AcquereurRegister() {
  return (
    <PlatformLayout searchDock={false} solidHeader preFooterCTA={false}>
      <AcquereurExperience postLoginPath="/espace-acquereurs" />
    </PlatformLayout>
  );
}
